import React, { useState, useEffect, useCallback } from 'react'
import { useFormik } from 'formik'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import ReplyRoundedIcon from '@material-ui/icons/ReplyRounded'

import { useUserProfile } from 'commons/useUserProfile'

import Creator from '../Creator'
import useReplyBox from './useReplyBox'
import CommentContainer from '../CommentContainer'

const ReplyBox = (props) => {
  const { id, data, onFetchCommentList } = props
  const {
    text,
    creator,
    editable,
    updatedAt,
    createdAt,
    id: replyId,
    status: replyStatus,
  } = data

  const profile = useUserProfile()
  const { formatMessage } = useIntl()

  const {
    state: { isUpdatingReply, isUpdateReplySuccess, isDeleteReplySuccess },
    reset,
    onDeleteReply,
    onUpdateReply,
  } = useReplyBox(id, replyId, profile.id, onFetchCommentList())

  const [isEditReply, setIsEditReply] = useState(false)
  const [isDeletedReply, setIsDeletedReply] = useState(false)

  const formik = useFormik({
    initialValues: {
      reply: '',
    },
  })

  const handleReset = useCallback(async () => {
    await setIsEditReply(false)
    reset()
  }, [reset])

  useEffect(() => {
    return () => {
      formik.resetForm()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isUpdateReplySuccess || isDeleteReplySuccess)
      setTimeout(() => {
        handleReset()
      }, 800)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateReplySuccess, isDeleteReplySuccess])

  return (
    <div className="w-full flex py-5">
      <ReplyRoundedIcon
        fontSize="small"
        style={{ transform: 'rotate(180deg)', color: '#5D7290' }}
      />
      <div className="w-full pl-5 space-y-5">
        {!isEditReply && (
          <Creator
            creator={creator}
            editable={editable}
            createdAt={createdAt}
            updatedAt={updatedAt}
            commentStatus={replyStatus}
            onEdit={() => setIsEditReply(true)}
            disabled={isDeletedReply || isEditReply}
            onDelete={() => {
              setIsDeletedReply(true)
              onDeleteReply()
            }}
          />
        )}
        <CommentContainer
          text={text}
          submitText={formatMessage({
            id: 'action.save',
          })}
          isInput={isEditReply}
          isLoading={isUpdatingReply}
          commentStatus={replyStatus}
          placeholder={`${formatMessage({ id: 'timeline.detail.message.edit.reply' })}....`}
          isSuccess={isUpdateReplySuccess}
          onClose={() => setIsEditReply(false)}
          onSubmit={async (value) => await onUpdateReply(value)}
        />
      </div>
    </div>
  )
}

const creator = {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastname: PropTypes.string,
  avatar: PropTypes.string,
  avatarCharacters: PropTypes.string,
  deletedAt: PropTypes.string,
  status: PropTypes.number,
}

ReplyBox.propTypes = {
  id: PropTypes.number,
  onFetchCommentList: PropTypes.func,
  data: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    creator: PropTypes.shape(creator),
    status: PropTypes.number,
    editable: PropTypes.number,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    replies: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        text: PropTypes.string,
        creator: PropTypes.shape(creator),
        status: PropTypes.number,
        editable: PropTypes.number,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
      }),
    ),
  }),
}

export default ReplyBox
